import {
  POS_TBL_LOADING,
  POS_TBL_AREAS,
  POS_TBL_TABLES,
  POS_TBL_RESERVATIONS,
  POS_TBL_STATUS,
  POS_TBL_WAITERS,
  POS_TBL_WAITER_REQUESTS,
} from "./actionTypes";

const initialState = {
  loading: false,
  areas: [],
  tables: [],
  reservations: [],
  statusBoard: [],
  waiters: [],
  waiterRequests: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_TBL_LOADING:
      return { ...state, loading: action.payload };
    case POS_TBL_AREAS:
      return { ...state, areas: action.payload };
    case POS_TBL_TABLES:
      return { ...state, loading: false, tables: action.payload };
    case POS_TBL_RESERVATIONS:
      return { ...state, loading: false, reservations: action.payload };
    case POS_TBL_STATUS:
      return { ...state, statusBoard: action.payload };
    case POS_TBL_WAITERS:
      return { ...state, waiters: action.payload };
    case POS_TBL_WAITER_REQUESTS:
      return { ...state, waiterRequests: action.payload };
    default:
      return state;
  }
}
